import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "task-checked",
  "use": "task-checked-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 18 18\" id=\"task-checked\"><circle cx=\"9\" cy=\"9\" r=\"7\" fill=\"#fff\" /><rect width=\"16\" height=\"16\" x=\"1\" y=\"1\" stroke=\"#6644EA\" stroke-width=\"2\" rx=\"8\" /><rect width=\"10\" height=\"10\" x=\"4\" y=\"4\" fill=\"#6644EA\" rx=\"5\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol